import React from 'react';
import { ResourceTypes, ResourceOperations } from '../../../authentication/resources';
import { Restricted } from '../../../authentication';
import { AdminLink, AdminHeaderLink, AdminRouterLink } from '../components/admin-area-menu-links';
import { joinURL } from '../../../utilities';
import { adminAreaPathName, templatesAndAppendixTabLabel, templatesAndAppendixTabPathName } from '../admin-area-pathnames';
import { standardAppendixRulePathName, standardAppendixPathName } from './templates-and-appendix-pathnames';
import { useTenantAddons } from '../../../components/tenant-addons';
import { moduleClientFactory } from '../../../api-service/module-client-factory';
import { GetDteUrlResponse } from '../../../api-service/clients';
import { useApiOnRender } from '../../../hooks';

export function TemplatesAndAppendixMenu() {
  const { isTenantAddonEnabled } = useTenantAddons();
  const configurationClient = moduleClientFactory.createConfigurationClient();
  const tenantDteUrlConfiguration = useApiOnRender(cancelToken => configurationClient.getDteUrl(cancelToken), {} as GetDteUrlResponse);

  function handleClick() {
    if (tenantDteUrlConfiguration?.result?.dteUrl) {
      window.open(tenantDteUrlConfiguration?.result?.dteUrl);
    }
  }
  return (
    <Restricted
      actions={[
        { resourceType: ResourceTypes.BusinessConfiguration, resourceOperation: ResourceOperations.Read },
        { resourceType: ResourceTypes.StandardAppendix, resourceOperation: ResourceOperations.Read },
      ]}
    >
      <AdminHeaderLink to={joinURL('/', adminAreaPathName, templatesAndAppendixTabPathName)}>{templatesAndAppendixTabLabel}</AdminHeaderLink>
      <AdminLink onClick={handleClick}>Skabeloner</AdminLink>
      <AdminLink onClick={handleClick}>Skabelonmapninger</AdminLink>

      {isTenantAddonEnabled(['standardbilag']) && (
        <AdminRouterLink to={joinURL('/', adminAreaPathName, templatesAndAppendixTabPathName, standardAppendixRulePathName)}>Regler for standardbilag</AdminRouterLink>
      )}
      {isTenantAddonEnabled(['standardbilag']) && (
        <AdminRouterLink to={joinURL('/', adminAreaPathName, templatesAndAppendixTabPathName, standardAppendixPathName)}>Standardbilag</AdminRouterLink>
      )}
    </Restricted>
  );
}
